// Mock data for Aadi Gayanam Play School

export const schoolInfo = {
  name: "Aadi Gayanam",
  tagline: "Play School",
  parentOrg: "Aarohi Welfare Foundation",
  motto: "Sanatan to Modern Education",
  sanskritMotto: "संस्कारेण प्रगतिः",
  logoUrl: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/6gq14f3m_WhatsApp%20Image%202026-07-15%20at%208.37.51%20PM.jpeg",
  location: "Jaipur, Rajasthan",
  email: "info@aadigayanam.com",
  website: "www.aadigayanam.com",
  phone: "+91 7617755821",
  address: "Aadi Gayanam Play School, Aarohi Welfare Foundation, Jaipur, Rajasthan - 302001",
  launchDate: "January 1, 2027",
  launchDateISO: "2027-01-01",
  established: "Launching Jan 2027",
  social: {
    facebook: "#",
    instagram: "#",
    youtube: "#",
    twitter: "#"
  }
};

export const brandedPosters = [
  {
    id: 1,
    url: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/u4qlvdvv_WhatsApp%20Image%202026-07-15%20at%208.43.27%20PM%20%287%29.jpeg",
    title: "Play, Learn, Grow, Shine",
    description: "Nurturing curious minds through outdoor play and nature-based learning."
  },
  {
    id: 2,
    url: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/hyz9y3ig_WhatsApp%20Image%202026-07-15%20at%208.43.27%20PM%20%288%29.jpeg",
    title: "Joyful Learning Everyday",
    description: "A vibrant classroom that inspires exploration, creativity and confidence."
  },
  {
    id: 3,
    url: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/mdv1x5gr_WhatsApp%20Image%202026-07-15%20at%208.43.27%20PM%20%289%29.jpeg",
    title: "We Pray Together, Grow Together",
    description: "Morning prayer, Sanskrit shlokas and value-based education begin our day."
  },
  {
    id: 4,
    url: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/nc82ua9d_WhatsApp%20Image%202026-07-15%20at%208.43.27%20PM%20%2811%29.jpeg",
    title: "Music, Stories & Sanskaar",
    description: "Where every song, every story shapes character and creativity."
  }
];

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Programs", path: "/programs" },
  { label: "Admission", path: "/admission" },
  { label: "Blog", path: "/blog" },
  { label: "Contact", path: "/contact" }
];

export const exploreLinks = [
  { label: "Knowledge House", path: "/knowledge-house", desc: "Stories of Bharat's leaders & fun corner" },
  { label: "Little Mind Craft Work", path: "/little-mind-craft-work", desc: "30 joyful crafts for tiny hands" },
  { label: "Virtual Tour", path: "/virtual-tour", desc: "Explore our campus" },
  { label: "Gallery", path: "/gallery", desc: "Life at Aadi Gayanam" },
  { label: "Photo Albums", path: "/albums", desc: "Memories by date" },
  { label: "Videos", path: "/videos", desc: "Watch our story" },
  { label: "Events", path: "/events", desc: "Upcoming & past" },
  { label: "Franchise", path: "/franchise", desc: "Partner with us" },
  { label: "Careers", path: "/careers", desc: "Join our team" }
];

export const videos = [
  {
    id: "vision-story",
    title: "Our Vision — A New Way to Learn",
    description: "Founders of Aadi Gayanam share the vision behind blending Sanatan values with modern learning for the youngest minds of Bharat.",
    category: "Vision",
    duration: "3:24",
    thumbnail: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=1200",
    youtubeId: "aqz-KE-bpKQ",
    featured: true
  },
  {
    id: "sanskrit-shlokas-kids",
    title: "Little Voices, Ancient Shlokas",
    description: "A beautiful glimpse of preschoolers reciting simple Sanskrit shlokas as part of our daily morning ritual.",
    category: "Sanskaar",
    duration: "2:15",
    thumbnail: "https://images.unsplash.com/photo-1594135356513-14291e55162a?w=1200",
    youtubeId: "aqz-KE-bpKQ"
  },
  {
    id: "yoga-for-kids",
    title: "Yoga & Movement for Preschoolers",
    description: "Watch how our little ones learn simple asanas and breathing games — combining play with mindfulness.",
    category: "Wellness",
    duration: "4:02",
    thumbnail: "https://images.unsplash.com/photo-1625865020971-581242d0ead6?w=1200",
    youtubeId: "aqz-KE-bpKQ"
  },
  {
    id: "campus-tour",
    title: "Virtual Campus Preview",
    description: "Take a virtual walkthrough of the upcoming Aadi Gayanam campus in Jaipur — designed keeping children's imagination in mind.",
    category: "Campus",
    duration: "5:30",
    thumbnail: "https://images.unsplash.com/photo-1692269725911-87697c558be1?w=1200",
    youtubeId: "aqz-KE-bpKQ"
  },
  {
    id: "storytelling",
    title: "Story Time — Panchatantra Tales",
    description: "Bharatiya stories that quietly plant the seeds of empathy, courage and wisdom in every child.",
    category: "Learning",
    duration: "3:48",
    thumbnail: "https://images.unsplash.com/photo-1569173675610-42c361a86e37?w=1200",
    youtubeId: "aqz-KE-bpKQ"
  },
  {
    id: "parent-testimonial",
    title: "Voices of Early Registrants",
    description: "Hear from parents who chose Aadi Gayanam even before its launch — and why they're so excited for January 2027.",
    category: "Testimonial",
    duration: "2:56",
    thumbnail: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=1200",
    youtubeId: "aqz-KE-bpKQ"
  }
];

export const heroSlides = [
  {
    id: 1,
    title: "Every Child Grows at",
    highlight: "Their Own Pace",
    subtitle: "A safe, nurturing and loving space where every little journey is treasured",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/wono8isz_f193f581-1117-4b3a-a991-ab53fcfc8c2a.png",
    cta: "Launching 1st January 2027"
  },
  {
    id: 2,
    title: "Join the Aadigayanam",
    highlight: "Family",
    subtitle: "An education that nurtures the mind, heart, body, creativity and character",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/zov36zwf_2e85e6a1-73f1-418d-8eb5-8ecff5d1ed24.png",
    cta: "Early Registrations Open"
  },
  {
    id: 3,
    title: "Early Childhood Education is",
    highlight: "Foundational",
    subtitle: "A strong beginning today builds a brighter tomorrow for your child",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/lowzbs79_f88ac0fc-5575-4850-8ca5-0234abec01f4.png",
    cta: "Reserve Your Seat Now"
  }
];

export const programs = [
  {
    id: "playgroup",
    name: "Playgroup",
    ageGroup: "1.5 - 2.5 Years",
    duration: "2.5 Hours/Day",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/8olo5nbe_843310eb-69be-4552-b257-13059de80f22.png",
    color: "bg-orange-50",
    accent: "bg-orange-500",
    description: "Little explorers begin their journey with sensory play, rhymes and Sanskrit sounds. We introduce curiosity through storytelling and movement.",
    highlights: ["Sensory Play", "Nursery Rhymes", "Basic Shlokas", "Motor Skills"]
  },
  {
    id: "nursery",
    name: "Nursery",
    ageGroup: "2.5 - 3.5 Years",
    duration: "3 Hours/Day",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/nnlhoc5j_e6f9a7e9-26bb-4e8b-be37-ecb0cedc24c5%20%281%29.png",
    color: "bg-amber-50",
    accent: "bg-amber-500",
    description: "Foundation-level learning blending phonics, numbers, storytelling and Vedic values through interactive play-based methods.",
    highlights: ["Phonics & Numbers", "Story Time", "Yoga for Kids", "Art & Craft"]
  },
  {
    id: "jrkg",
    name: "Junior KG",
    ageGroup: "3.5 - 4.5 Years",
    duration: "3.5 Hours/Day",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/3qskfclr_b1d5ea23-9a66-4e57-8357-dd620b233c12.png",
    color: "bg-rose-50",
    accent: "bg-rose-500",
    description: "Structured learning with reading, writing readiness, environmental awareness and Bharatiya cultural traditions.",
    highlights: ["Reading Readiness", "Sanskrit Shlokas", "Music & Dance", "Life Skills"]
  },
  {
    id: "srkg",
    name: "Senior KG",
    ageGroup: "4.5 - 5.5 Years",
    duration: "4 Hours/Day",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/yd9q1oo4_4b88ef8c-414c-45bb-bc6f-85d092f5c7b8.png",
    color: "bg-yellow-50",
    accent: "bg-yellow-500",
    description: "School-readiness program with confident communication, early math, Bharat gyaan and value-based education.",
    highlights: ["School Readiness", "Public Speaking", "Vedic Math Basics", "Leadership"]
  },
  {
    id: "daycare",
    name: "Day Care",
    ageGroup: "1.5 - 6 Years",
    duration: "Flexible Hours",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/l49g3l61_62e5bb7f-9e6a-490f-87c6-e45c4b9b15e7.png",
    color: "bg-teal-50",
    accent: "bg-teal-500",
    description: "A safe home-away-from-home with nutritious meals, nap time, activities and loving caregivers.",
    highlights: ["Safe Environment", "Healthy Meals", "Nap Time", "Fun Activities"]
  },
  {
    id: "sanskar",
    name: "Sanskar Kendra",
    ageGroup: "All Ages",
    duration: "Weekend Sessions",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_gayanam-preschool/artifacts/qj16ocmv_9c49ff80-f060-4ff8-a58b-8f3fb649ecee.png",
    color: "bg-lime-50",
    accent: "bg-lime-600",
    description: "Weekend program teaching Sanskrit shlokas, Bhagavad Gita stories, yoga and traditional Bharatiya values.",
    highlights: ["Shloka Recitation", "Yoga & Pranayam", "Story of Gods", "Cultural Arts"]
  }
];

export const shlokas = [
  {
    id: 1,
    title: "Guru Vandana",
    devanagari: "गुरुर्ब्रह्मा गुरुर्विष्णुः गुरुर्देवो महेश्वरः।\nगुरुः साक्षात् परब्रह्म तस्मै श्री गुरवे नमः॥",
    transliteration: "Gururbrahma Gururvishnuh Gururdevo Maheshwarah,\nGuruh Sakshat Parabrahma Tasmai Shri Gurave Namah.",
    meaning: "The Guru is Brahma, Vishnu, and Shiva. The Guru is the Supreme Being. Salutations to that revered Guru."
  },
  {
    id: 2,
    title: "Vakratunda Mahakaya",
    devanagari: "वक्रतुण्ड महाकाय सूर्यकोटि समप्रभ।\nनिर्विघ्नं कुरु मे देव सर्वकार्येषु सर्वदा॥",
    transliteration: "Vakratunda Mahakaya Suryakoti Samaprabha,\nNirvighnam Kuru Me Deva Sarvakaryeshu Sarvada.",
    meaning: "O Lord Ganesha with a curved trunk and mighty body, radiant like a million suns, please remove all obstacles in my endeavors."
  },
  {
    id: 3,
    title: "Saraswati Vandana",
    devanagari: "या कुन्देन्दु तुषारहार धवला या शुभ्रवस्त्रावृता।\nया वीणावरदण्डमण्डितकरा या श्वेतपद्मासना॥",
    transliteration: "Ya Kundendu Tushara Hara Dhavala Ya Shubhravastravrita,\nYa Vinavaradanda Mandita Kara Ya Shwetapadmasana.",
    meaning: "Salutations to Goddess Saraswati, who is white like jasmine, adorned in white, holds the veena, seated on a white lotus."
  },
  {
    id: 4,
    title: "Gayatri Mantra",
    devanagari: "ॐ भूर्भुवः स्वः।\nतत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि।\nधियो यो नः प्रचोदयात्॥",
    transliteration: "Om Bhur Bhuvah Swah,\nTat Savitur Varenyam,\nBhargo Devasya Dhimahi,\nDhiyo Yo Nah Prachodayat.",
    meaning: "We meditate on the divine light of the Sun. May it illuminate our intellect and guide us on the right path."
  }
];

export const features = [
  {
    icon: "Sparkles",
    title: "Holistic Development",
    description: "Blending traditional Sanatan wisdom with modern early childhood education for well-rounded growth."
  },
  {
    icon: "Users",
    title: "Expert Educators",
    description: "Trained, loving teachers with expertise in early childhood care and Bharatiya cultural values."
  },
  {
    icon: "ShieldCheck",
    title: "Safe & Secure",
    description: "CCTV monitored, hygienic and child-friendly environment ensuring complete safety and peace of mind."
  },
  {
    icon: "Palette",
    title: "Creative Learning",
    description: "Art, music, dance, storytelling and play-based methodologies to spark creativity and imagination."
  },
  {
    icon: "Flower2",
    title: "Yoga & Meditation",
    description: "Daily yoga, pranayam and simple meditation practices to nurture body and mind harmony."
  },
  {
    icon: "BookOpen",
    title: "Sanskrit Shlokas",
    description: "Age-appropriate Sanskrit shlokas, stories from Ramayana & Mahabharata for cultural grounding."
  }
];

export const galleryImages = [
  { id: 1, url: "https://images.unsplash.com/photo-1517673132405-a56a62b18caf?w=800", caption: "Happy Faces" },
  { id: 2, url: "https://images.unsplash.com/photo-1657098439949-fee638f883cc?w=800", caption: "Art & Craft" },
  { id: 3, url: "https://images.unsplash.com/photo-1576381394626-53b3d2d48145?w=800", caption: "Outdoor Play" },
  { id: 4, url: "https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=800", caption: "Yoga Session" },
  { id: 5, url: "https://images.unsplash.com/photo-1596464716127-f2a82984de30?w=800", caption: "Classroom Learning" },
  { id: 6, url: "https://images.unsplash.com/photo-1764791485255-39c3d07bf243?w=800", caption: "Cultural Celebration" },
  { id: 7, url: "https://images.unsplash.com/photo-1567721913486-6585f069b332?w=800", caption: "School Friends" },
  { id: 8, url: "https://images.unsplash.com/photo-1610674632272-2d3e9a345453?w=800", caption: "Play Time" },
  { id: 9, url: "https://images.unsplash.com/photo-1553481187-be93c21490a9?w=800", caption: "Group Activities" }
];

export const testimonials = [
  {
    id: 1,
    name: "Dr. Meera Vyas",
    role: "Advisory Board — ECCE Expert",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200",
    quote: "Aadi Gayanam's vision to seamlessly blend Sanatan values with modern pedagogy is exactly what today's Indian children need. I am proud to advise this pioneering initiative launching in January 2027."
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Early Registrant • Playgroup",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200",
    quote: "The moment I heard about Aadi Gayanam's philosophy, I knew this was for my son. The blend of shlokas and modern learning is exactly what we were looking for. Excited for 2027!"
  },
  {
    id: 3,
    name: "Acharya Ramesh Ji",
    role: "Sanskrit Curriculum Advisor",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200",
    quote: "A play school that respects Sanatan heritage while embracing modern learning is a rare gem. Aadi Gayanam is set to raise a generation of rooted yet forward-looking children."
  },
  {
    id: 4,
    name: "Rajesh Agarwal",
    role: "Early Registrant • Junior KG",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200",
    quote: "We booked our daughter's seat the day registrations opened. The team's vision, curriculum and infrastructure plans are truly world-class. Cannot wait for Jan 2027!"
  }
];

export const faqs = [
  {
    q: "When is Aadi Gayanam Play School opening?",
    a: "Our grand launch is on 1st January 2027. Early registrations for the 2027-28 academic year are currently open. Book your child's seat early to secure priority admission."
  },
  {
    q: "What age group will Aadi Gayanam cater to?",
    a: "We will welcome children from 1.5 years to 6 years across Playgroup, Nursery, Junior KG and Senior KG programs. Day Care will be available for all age groups."
  },
  {
    q: "How is Aadi Gayanam different from other play schools?",
    a: "We uniquely blend Sanatan values (Sanskrit shlokas, yoga, Bharatiya stories, sanskar) with modern learning pedagogies (phonics, STEM basics, life skills). This creates well-rounded, rooted-yet-progressive children."
  },
  {
    q: "What will be the teacher-to-student ratio?",
    a: "We will maintain a low ratio of 1:8 for Playgroup and 1:12 for other classes, ensuring personalized attention to every child."
  },
  {
    q: "Will you provide transport and meals?",
    a: "Yes, we will offer safe transport with GPS-tracked vehicles and trained attendants. Fresh, nutritious sattvik meals will be provided as per subscription."
  },
  {
    q: "How can I register early for admission?",
    a: "You can fill our online early enquiry form, or call +91 7617755821. Early registrants get priority seat allocation and a special launch discount when the school opens in January 2027."
  }
];

export const events = [
  {
    id: "info-session-2026-09",
    title: "Founder's Vision Session",
    date: "2026-09-14",
    time: "5:00 PM - 6:30 PM",
    location: "Aarohi Welfare Foundation, Jaipur",
    category: "Info Session",
    image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800",
    description: "Meet our founders and academic team. Learn about our unique Sanatan + Modern curriculum, campus plans and admission process for the 2027 launch.",
    status: "upcoming"
  },
  {
    id: "open-house-2026-10",
    title: "Virtual Open House",
    date: "2026-10-05",
    time: "11:00 AM - 12:30 PM",
    location: "Zoom (Link will be shared on registration)",
    category: "Open House",
    image: "https://images.unsplash.com/photo-1587145820266-a5951ee6f620?w=800",
    description: "A live walkthrough of our curriculum, teaching methodology, safety protocols and a Q&A session with our academic head. Perfect for parents from anywhere.",
    status: "upcoming"
  },
  {
    id: "diwali-workshop-2026",
    title: "Diwali Sanskar Workshop (For Parents)",
    date: "2026-11-08",
    time: "4:00 PM - 6:00 PM",
    location: "Aarohi Welfare Foundation, Jaipur",
    category: "Workshop",
    image: "https://images.unsplash.com/photo-1533228876829-65c94e7b5025?w=800",
    description: "A hands-on workshop for parents on introducing festivals, shlokas and cultural values to preschoolers in a fun, engaging way.",
    status: "upcoming"
  },
  {
    id: "teacher-recruitment-drive-2026",
    title: "Teacher Recruitment Drive",
    date: "2026-11-25",
    time: "10:00 AM - 4:00 PM",
    location: "Aarohi Welfare Foundation, Jaipur",
    category: "Recruitment",
    image: "https://images.unsplash.com/photo-1587653263995-422546a7a569?w=800",
    description: "Calling passionate ECCE professionals, Sanskrit educators, yoga instructors and childcare experts to join our founding faculty team.",
    status: "upcoming"
  },
  {
    id: "sanskrit-fest-2026-12",
    title: "Bal Sanskrit Utsav",
    date: "2026-12-14",
    time: "3:00 PM - 5:00 PM",
    location: "Aarohi Welfare Foundation, Jaipur",
    category: "Cultural",
    image: "https://images.unsplash.com/photo-1544027993-37dbfe43562a?w=800",
    description: "A festival celebrating Sanskrit shlokas, storytelling and cultural performances. Registered families welcome!",
    status: "upcoming"
  },
  {
    id: "grand-launch-2027",
    title: "Grand Launch — First Day of School",
    date: "2027-01-01",
    time: "9:00 AM onwards",
    location: "Aadi Gayanam Play School Campus, Jaipur",
    category: "Milestone",
    image: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=800",
    description: "Our historic first day! Blessing ceremony, ribbon cutting, cultural performances by faculty and welcoming our first batch of little learners.",
    status: "milestone"
  },
  {
    id: "site-inauguration-2025",
    title: "Site Bhumi Pujan",
    date: "2025-06-15",
    time: "7:30 AM",
    location: "Aadi Gayanam Campus Site, Jaipur",
    category: "Milestone",
    image: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=800",
    description: "Traditional bhumi pujan ceremony marking the start of campus construction, attended by patrons, well-wishers and the Aarohi Welfare Foundation trustees.",
    status: "past"
  },
  {
    id: "curriculum-summit-2026-03",
    title: "Curriculum Design Summit",
    date: "2026-03-22",
    time: "10:00 AM - 5:00 PM",
    location: "Aarohi Welfare Foundation, Jaipur",
    category: "Milestone",
    image: "https://images.pexels.com/photos/3661380/pexels-photo-3661380.jpeg?w=800",
    description: "A two-day summit with ECCE experts, Sanskrit scholars and modern educators finalizing our unique Sanatan-to-Modern curriculum framework.",
    status: "past"
  }
];

export const careers = [
  {
    id: "founding-teachers-2026",
    title: "Founding Preschool Teachers",
    department: "Academics",
    type: "Full Time",
    location: "Jaipur, Rajasthan",
    experience: "2-5 years in ECCE",
    postedDate: "2026-06-10",
    description: "Be part of our founding faculty team! We are looking for passionate, trained preschool educators who love working with young children and are excited about blending Sanatan values with modern pedagogy.",
    responsibilities: [
      "Plan and deliver play-based lessons for children aged 1.5 to 6 years",
      "Introduce Sanskrit shlokas, storytelling and yoga in an engaging manner",
      "Maintain a safe, warm and inspiring classroom environment",
      "Communicate regularly with parents on child development"
    ],
    requirements: [
      "Bachelor's degree with ECCE certification/diploma",
      "2+ years of experience in a play school or nursery",
      "Comfort with basic Sanskrit and traditional Indian stories",
      "Loving, patient temperament with a passion for teaching"
    ]
  },
  {
    id: "sanskrit-educator-2026",
    title: "Sanskrit & Sanskaar Educator",
    department: "Academics",
    type: "Full Time / Visiting",
    location: "Jaipur, Rajasthan",
    experience: "3+ years",
    postedDate: "2026-06-20",
    description: "Lead our Sanskrit and Sanskaar curriculum. Teach children (and train fellow teachers) simple shlokas, mantras, cultural stories and Bharatiya values in a playful, age-appropriate way.",
    responsibilities: [
      "Design age-appropriate Sanskrit shloka curriculum",
      "Conduct daily shloka and prayer sessions",
      "Storytelling from Ramayana, Mahabharata, Panchatantra",
      "Train fellow teachers in basic Sanskrit"
    ],
    requirements: [
      "Graduate/PG in Sanskrit or Sanskrit teaching experience",
      "Excellent storytelling skills",
      "Warm personality; ability to work with small children",
      "Fluent in Hindi and English"
    ]
  },
  {
    id: "yoga-instructor-2026",
    title: "Kids Yoga & Movement Instructor",
    department: "Wellness",
    type: "Part Time",
    location: "Jaipur, Rajasthan",
    experience: "2+ years",
    postedDate: "2026-07-01",
    description: "Bring yoga, pranayam and joyful movement into the lives of our little ones. You will lead daily wellness sessions that are as playful as they are grounding.",
    responsibilities: [
      "Conduct 30-minute yoga/movement sessions daily",
      "Design age-appropriate asanas and breathing games",
      "Collaborate with class teachers on wellness integration",
      "Ensure safety and joyful participation"
    ],
    requirements: [
      "Certified yoga instructor (200 hrs+)",
      "Prior experience with children preferred",
      "Energetic, patient and playful attitude"
    ]
  },
  {
    id: "admin-coordinator-2026",
    title: "Admissions & Operations Coordinator",
    department: "Administration",
    type: "Full Time",
    location: "Jaipur, Rajasthan",
    experience: "3+ years",
    postedDate: "2026-07-15",
    description: "Handle admissions, parent enquiries, campus operations and coordinate with vendors as we build towards our January 2027 launch.",
    responsibilities: [
      "Handle admission enquiries and campus tours",
      "Manage day-to-day operational activities",
      "Coordinate with vendors, transport, meals partners",
      "Support parent communication and events"
    ],
    requirements: [
      "Graduate with excellent communication skills",
      "3+ years in school admin/customer relations",
      "Strong MS Office / Google Workspace skills",
      "Warm, service-oriented personality"
    ]
  },
  {
    id: "caregiver-daycare-2026",
    title: "Daycare Caregiver (Ayah)",
    department: "Care",
    type: "Full Time",
    location: "Jaipur, Rajasthan",
    experience: "1+ years",
    postedDate: "2026-08-01",
    description: "Loving, motherly caregivers to support our smallest students with feeding, nap time, hygiene and play. This role is the heart of our nurturing environment.",
    responsibilities: [
      "Support children with meals, hygiene, nap time",
      "Assist teachers during class transitions",
      "Maintain a clean, safe and loving environment",
      "Communicate any child concerns to teachers"
    ],
    requirements: [
      "10+2 minimum; ECCE certification is a plus",
      "Prior experience with young children",
      "Patient, kind and reliable temperament"
    ]
  }
];

export const franchisePackages = [
  {
    id: "essential",
    name: "Essential",
    setup: "₹8 - 12 Lakhs",
    space: "1500 - 2500 sq.ft.",
    color: "bg-amber-50",
    accent: "bg-amber-500",
    tier: "Tier 3 Cities & Towns",
    features: [
      "Complete curriculum & pedagogy",
      "Brand identity and marketing kit",
      "Teacher training program",
      "Setup guidance & manuals",
      "Ongoing academic support"
    ]
  },
  {
    id: "premium",
    name: "Premium",
    setup: "₹15 - 25 Lakhs",
    space: "2500 - 4500 sq.ft.",
    color: "bg-orange-50",
    accent: "bg-orange-500",
    popular: true,
    tier: "Tier 2 Cities",
    features: [
      "Everything in Essential",
      "Advanced infrastructure design",
      "Signature Sanskaar Program",
      "Digital learning tools & apps",
      "Marketing campaign support",
      "Quarterly training refreshers"
    ]
  },
  {
    id: "flagship",
    name: "Flagship",
    setup: "₹30 - 50 Lakhs",
    space: "4500+ sq.ft.",
    color: "bg-rose-50",
    accent: "bg-rose-500",
    tier: "Metros & Tier 1 Cities",
    features: [
      "Everything in Premium",
      "Premium campus architecture",
      "Full day-care integration",
      "STEM & Robotics labs",
      "Dedicated success manager",
      "Priority parent lead generation"
    ]
  }
];

export const photoAlbums = [
  {
    id: "site-bhumi-pujan-2025",
    title: "Site Bhumi Pujan Ceremony",
    date: "2025-06-15",
    coverImage: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800",
    photoCount: 24,
    description: "The auspicious start of our campus construction with a traditional Vedic ceremony.",
    photos: [
      "https://images.unsplash.com/photo-1602934585418-f588bea4215c?w=1200",
      "https://images.pexels.com/photos/8618083/pexels-photo-8618083.jpeg?w=800",
      "https://images.unsplash.com/photo-1587616211892-f743fcca64f9?w=1200",
      "https://images.unsplash.com/photo-1567095761054-7a02e69e5c43?w=1200"
    ]
  },
  {
    id: "curriculum-summit-march-2026",
    title: "Curriculum Design Summit",
    date: "2026-03-22",
    coverImage: "https://images.unsplash.com/photo-1544025162-d76694265947?w=800",
    photoCount: 32,
    description: "Two days of intense collaboration among ECCE experts and Sanskrit scholars to shape our unique curriculum.",
    photos: [
      "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=1200",
      "https://images.unsplash.com/photo-1441057206919-63d19fac2369?w=1200",
      "https://images.unsplash.com/photo-1522543558187-768b6df7c25c?w=1200",
      "https://images.unsplash.com/photo-1520006403909-838d6b92c22e?w=1200"
    ]
  },
  {
    id: "faculty-training-june-2026",
    title: "Founding Faculty Training",
    date: "2026-06-05",
    coverImage: "https://images.pexels.com/photos/5088186/pexels-photo-5088186.jpeg?w=800",
    photoCount: 45,
    description: "Our first cohort of teachers undergoing intensive training in ECCE, Sanskrit and modern pedagogy.",
    photos: [
      "https://images.pexels.com/photos/4144099/pexels-photo-4144099.jpeg?w=800",
      "https://images.pexels.com/photos/3661381/pexels-photo-3661381.jpeg?w=800",
      "https://images.pexels.com/photos/3661382/pexels-photo-3661382.jpeg?w=800",
      "https://images.unsplash.com/photo-1583324113626-70df0f4deaab?w=1200"
    ]
  },
  {
    id: "community-outreach-april-2026",
    title: "Community Outreach Program",
    date: "2026-04-10",
    coverImage: "https://images.pexels.com/photos/8535233/pexels-photo-8535233.jpeg?w=800",
    photoCount: 28,
    description: "Meeting local families in Jaipur, sharing our vision and inviting them to join our founding community.",
    photos: [
      "https://images.unsplash.com/photo-1541696490-8744a5dc0228?w=1200",
      "https://images.unsplash.com/photo-1543269664-7eef42226a21?w=1200",
      "https://images.unsplash.com/photo-1603185030522-05d4497bb180?w=1200",
      "https://images.unsplash.com/photo-1630864972901-052dfdc7fba4?w=1200"
    ]
  },
  {
    id: "campus-construction-oct-2025",
    title: "Campus Construction Milestone",
    date: "2025-10-20",
    coverImage: "https://images.unsplash.com/photo-1526379095098-d400fd0bf935?w=800",
    photoCount: 18,
    description: "Foundation and structural work reaching key milestone as we build a world-class play school in Jaipur.",
    photos: [
      "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200",
      "https://images.pexels.com/photos/8613315/pexels-photo-8613315.jpeg?w=800",
      "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=1200"
    ]
  },
  {
    id: "sanskrit-workshop-jul-2026",
    title: "Sanskrit Curriculum Workshop",
    date: "2026-07-18",
    coverImage: "https://images.pexels.com/photos/8613303/pexels-photo-8613303.jpeg?w=800",
    photoCount: 22,
    description: "Interactive workshop with Acharya Ramesh Ji to finalize age-appropriate Sanskrit shlokas for our curriculum.",
    photos: [
      "https://images.pexels.com/photos/8535154/pexels-photo-8535154.jpeg?w=800",
      "https://images.unsplash.com/photo-1560421683-6856ea585c78?w=1200",
      "https://images.pexels.com/photos/3662628/pexels-photo-3662628.jpeg?w=800"
    ]
  }
];

export const stats = [
  { number: "Jan 2027", label: "Grand Launch" },
  { number: "6", label: "Programs Planned" },
  { number: "1:8", label: "Teacher Ratio" },
  { number: "150+", label: "Early Registrations" }
];

export const blogs = [
  {
    id: "what-makes-early-childhood-education-essential",
    title: "What Makes Early Childhood Education Essential? | Aadi Gayanam Play School",
    excerpt: "The first six years of a child's life are the most crucial. Early childhood education is not about academics — it is about building the foundation of a lifetime of learning, love, and character.",
    image: "https://images.pexels.com/photos/8613089/pexels-photo-8613089.jpeg?w=1200",
    author: "Team Aadi Gayanam",
    date: "2026-07-20",
    readTime: "11 min read",
    category: "Early Childhood",
    featured: true,
    sanskritQuote: {
      sanskrit: "बाल्यकालः जीवनस्य आधारः, तत्र दत्ता शिक्षा एव भाग्यनिर्मात्री।",
      meaning: "Childhood is the foundation of life — the education given in these years shapes the destiny of a human being. At Aadi Gayanam, we honour these precious years with love, wisdom, and the finest early childhood education."
    },
    sections: [
      { type: "paragraph", text: "The first six years of a child's life are the most extraordinary. In these tender years, more than 85% of the brain's core architecture is formed. Every hug, every song, every story, every playful discovery quietly shapes who the child will grow up to become." },
      { type: "paragraph", text: "This is why early childhood education (ECE) is not simply the first step of schooling — it is the most important step. It is not about teaching a two-year-old to read or a three-year-old to write. It is about creating an environment where curiosity, kindness, confidence and character grow naturally, side by side." },
      { type: "paragraph", text: "At Aadi Gayanam Play School, we treat these years with the reverence they deserve. Our approach blends the timeless wisdom of Sanatan values with the best of modern child development science, so every child begins life with a strong, joyful and rooted foundation." },
      {
        type: "image",
        src: "https://images.pexels.com/photos/8535230/pexels-photo-8535230.jpeg?w=1200",
        caption: "The early years are where wonder, warmth and wisdom take root."
      },

      { type: "heading", text: "What Is Early Childhood Education?" },
      { type: "paragraph", text: "Early childhood education refers to structured, developmentally appropriate learning experiences for children between the ages of about 18 months and 6 years. It includes playgroup, nursery, junior KG and senior KG stages." },
      { type: "paragraph", text: "But at its heart, ECE is not just a curriculum — it is a philosophy. It says that children learn best when they feel safe, seen and celebrated." },
      { type: "paragraph", text: "A meaningful early childhood programme includes:" },
      { type: "bullets", items: [
        "Play-based learning that respects the child's pace",
        "Age-appropriate language, math and science exposure",
        "Rich emotional and social experiences",
        "Music, movement, art and storytelling",
        "Yoga, mindfulness and physical development",
        "Cultural grounding through festivals, values and traditions",
        "Warm, trained teachers who respond to each child with love"
      ]},

      { type: "heading", text: "Why the Early Years Matter So Much" },
      { type: "paragraph", text: "Modern neuroscience and ancient Bharatiya wisdom agree on one truth — the mind of a child is like a garden. Whatever we plant in these early years grows quietly, deeply and stays for a lifetime." },

      { type: "subheading", text: "1. Rapid Brain Development" },
      { type: "paragraph", text: "Between birth and age six, a child's brain forms more than one million neural connections every second. These connections are shaped by everyday experiences — being spoken to, being read to, being loved, being allowed to play, explore and ask questions." },
      { type: "paragraph", text: "A quality early childhood environment enriches these connections. A poor or neglected one wastes them." },

      { type: "subheading", text: "2. Language Explosion" },
      { type: "paragraph", text: "The early years are the golden window for language learning. Children can absorb multiple languages, sounds, songs and rhymes with astonishing ease. This is the perfect age to introduce Sanskrit shlokas, Hindi rhymes and English phonics — not to burden the child, but to gently nourish the mind." },

      { type: "subheading", text: "3. Emotional and Social Foundation" },
      { type: "paragraph", text: "How a child feels about themselves and others is largely shaped before age six. Loving classrooms, respectful teachers and cooperative play teach children essential life skills — sharing, patience, empathy, courage and kindness." },

      { type: "subheading", text: "4. Habits That Last a Lifetime" },
      { type: "paragraph", text: "The habits of eating well, sleeping well, listening carefully, respecting elders, being clean, being punctual and being honest are all planted in early childhood. A good ECE programme reinforces these habits every day, gently and consistently." },

      { type: "subheading", text: "5. Confidence and Independence" },
      { type: "paragraph", text: "Children who experience a warm, encouraging early education develop a stronger sense of self. They believe they can try, fail, learn and try again. This resilience becomes the foundation of academic success and personal happiness later in life." },

      { type: "heading", text: "The Core Benefits of Early Childhood Education" },

      { type: "subheading", text: "Cognitive Growth" },
      { type: "bullets", items: [
        "Sharper memory and concentration",
        "Better problem-solving and reasoning",
        "Stronger vocabulary and expression",
        "Early love for books and stories",
        "Curiosity that lasts a lifetime"
      ]},

      { type: "subheading", text: "Emotional Growth" },
      { type: "bullets", items: [
        "Ability to identify and express feelings",
        "Confidence to try new things",
        "Patience during small challenges",
        "Empathy for friends and family",
        "Emotional resilience"
      ]},

      { type: "subheading", text: "Social Growth" },
      { type: "bullets", items: [
        "Comfort in group settings",
        "Sharing, turn-taking and cooperation",
        "Respect for teachers and elders",
        "Healthy friendships",
        "Peaceful conflict resolution"
      ]},

      { type: "subheading", text: "Physical Growth" },
      { type: "bullets", items: [
        "Strong gross and fine motor skills",
        "Better coordination and balance",
        "Daily yoga, movement and outdoor play",
        "Healthy eating habits",
        "Body awareness and energy"
      ]},

      { type: "subheading", text: "Cultural & Moral Growth" },
      { type: "bullets", items: [
        "Familiarity with Bharatiya festivals and traditions",
        "Simple shlokas and gratitude practices",
        "Stories of great souls that shape character",
        "Values of honesty, humility and service",
        "Respect for nature and all beings"
      ]},

      { type: "heading", text: "Why Play Is the Real Curriculum" },
      { type: "paragraph", text: "Adults often ask, \"But when will my child actually learn?\" The answer is beautiful: children are always learning. And they learn best through play." },
      { type: "paragraph", text: "Play is not the opposite of learning — play is the highest form of learning for a young child. When a child builds a block tower, they are learning physics. When they play pretend, they are learning empathy. When they sing a shloka, they are learning language, memory and devotion. When they run outdoors, they are learning coordination, courage and community." },
      { type: "paragraph", text: "At Aadi Gayanam, every activity is designed as joyful play with a hidden layer of learning." },

      {
        type: "image",
        src: "https://images.pexels.com/photos/8613310/pexels-photo-8613310.jpeg?w=1200",
        caption: "In a child's world, play is the doorway to lifelong learning."
      },

      { type: "heading", text: "The Aadi Gayanam Approach to Early Childhood Education" },
      { type: "paragraph", text: "We have designed our programme around five gentle promises to every child and family who joins us." },

      { type: "subheading", text: "1. A Safe and Loving Space" },
      { type: "paragraph", text: "Warm teachers, hygienic classrooms, small group sizes and a home-like atmosphere ensure children feel secure enough to explore, express and thrive." },

      { type: "subheading", text: "2. A Balanced Curriculum" },
      { type: "paragraph", text: "We blend the best of both worlds:" },
      { type: "bullets", items: [
        "Phonics, early literacy and communication",
        "Numeracy, patterns and early math concepts",
        "Sanskrit shlokas, Hindi and English rhymes",
        "Storytelling from Ramayana, Panchatantra and world tales",
        "Yoga, dance, music and art",
        "Nature-based exploration and sensory play",
        "Life skills, sanskaar and everyday values"
      ]},

      { type: "subheading", text: "3. Respect for the Child's Individuality" },
      { type: "paragraph", text: "No two children are the same. Our teachers observe each child, celebrate their strengths and gently support them where they need extra care. We follow the child — we don't push them." },

      { type: "subheading", text: "4. A Sanskaar-First Environment" },
      { type: "paragraph", text: "Values are not lectured; they are lived. Whether it is starting the day with a short prayer, sharing snacks, thanking the earth for a meal, or celebrating festivals — every moment is an opportunity to plant a seed of sanskaar." },

      { type: "subheading", text: "5. A True Partnership with Parents" },
      { type: "paragraph", text: "Parents are our co-teachers. Through regular updates, parent-teacher conversations, workshops and cultural events, we walk the journey together." },

      { type: "heading", text: "What a Typical Day Looks Like at Aadi Gayanam" },
      { type: "bullets", items: [
        "Warm welcome and morning circle",
        "Prayer, Sanskrit shloka and gratitude time",
        "Play-based learning stations (language, math, sensory, science)",
        "Snack break with mindful eating",
        "Outdoor play, yoga and free movement",
        "Creative expression — art, music, dance or drama",
        "Story time from Bharatiya and world tales",
        "Reflection, gratitude and a joyful goodbye"
      ]},
      { type: "paragraph", text: "Each moment of the day is designed to nourish the head, heart, hands and habits of the child." },

      { type: "heading", text: "Signs of a High-Quality Early Childhood Programme" },
      { type: "paragraph", text: "As a parent, when you evaluate any early learning centre, look for:" },
      { type: "bullets", items: [
        "Warm, trained and patient teachers",
        "Low teacher-to-child ratio",
        "Safe, clean and child-friendly environment",
        "Play-based, developmentally appropriate curriculum",
        "Focus on holistic development — not just academics",
        "Cultural rootedness with modern relevance",
        "Regular parent communication",
        "Joyful, calm and welcoming atmosphere",
        "Clear safety protocols and hygiene standards"
      ]},

      { type: "heading", text: "Common Myths About Early Childhood Education" },

      { type: "subheading", text: "Myth 1: \"My child is too young to learn.\"" },
      { type: "paragraph", text: "Children begin learning from the day they are born. The early years are the most powerful learning phase of a human being's life. Good ECE simply channels this learning in the right direction." },

      { type: "subheading", text: "Myth 2: \"Play school is just a place to keep kids busy.\"" },
      { type: "paragraph", text: "A good play school is much more. It is where children build language, social skills, confidence, discipline, emotional maturity and a lifelong love for learning." },

      { type: "subheading", text: "Myth 3: \"My child should already be reading and writing.\"" },
      { type: "paragraph", text: "Forcing academics too early can damage a child's confidence and curiosity. Reading and writing readiness happens naturally when the foundation is strong." },

      { type: "subheading", text: "Myth 4: \"Sanskrit and shlokas are too traditional for young kids.\"" },
      { type: "paragraph", text: "On the contrary — the melodic, rhythmic nature of Sanskrit shlokas is perfect for young children. They build memory, pronunciation, focus and cultural pride effortlessly." },

      { type: "heading", text: "Why Aadi Gayanam Is Different" },
      { type: "paragraph", text: "In a world that often rushes children, Aadi Gayanam Play School stands for something rare — a childhood that is unhurried, joyful, grounded and deeply loving." },
      { type: "paragraph", text: "Our children will not just learn ABCs and 123s. They will learn to say a shloka with sparkle in their eyes, to greet a friend with warmth, to help without being asked, to imagine boldly and to smile easily. They will step out of Aadi Gayanam not as toddlers with information, but as little souls with a strong foundation for life." },

      { type: "heading", text: "A Message to Parents" },
      { type: "paragraph", text: "Dear parents, these early years will never come back. Once your child steps into big school, the pace of life will change forever. So please, treasure these tender years." },
      { type: "paragraph", text: "Choose an environment where your child is not just taught, but treasured. Where every teacher looks at your child the way you do — with love. Where every day is designed around joy, curiosity, kindness and character." },
      { type: "paragraph", text: "This is exactly what we have built at Aadi Gayanam Play School. And we would be honoured to walk this beautiful early journey with you and your child." },

      { type: "heading", text: "In Closing" },
      { type: "paragraph", text: "Early childhood education is not preparation for real life — it is the most important part of real life. The seeds we plant in these years shape the tree that will one day give shade to families, communities and Bharat." },
      { type: "paragraph", text: "Give your child a beginning that is joyful, rooted and full of love. Give them Aadi Gayanam." }
    ],
    content: "The first six years of a child's life are the most crucial. Early childhood education is not about academics — it is about building the foundation of a lifetime of learning, love, and character."
  },
  {
    id: "aadi-gayanam-way-nurturing-complete-child",
    title: "The Aadi Gayanam Way: Nurturing the Complete Child",
    excerpt: "Join the Aadi Gayanam family and give your child an education that nurtures the mind, heart, body, creativity, and character. Together, let us build a generation that learns with joy, leads with wisdom, and lives with purpose.",
    image: "https://images.pexels.com/photos/20556421/pexels-photo-20556421.jpeg?w=1200",
    author: "Team Aadi Gayanam",
    date: "2026-07-19",
    readTime: "8 min read",
    category: "Philosophy",
    featured: true,
    sanskritQuote: {
      sanskrit: "सा विद्या या विमुक्तये।",
      meaning: "True education is that which sets us free — free in thought, free in heart, and free to become the best version of ourselves. This is the Aadi Gayanam promise to every child who joins our family."
    },
    sections: [
      { type: "paragraph", text: "Every child who walks into Aadi Gayanam Play School carries a universe of possibility. Our role is not to fill this universe with information — it is to help each child discover the light already within." },
      { type: "paragraph", text: "That is why our approach is designed around one simple belief: a child is not a subject to be taught, but a soul to be nurtured. Real education must reach every part of the child — the mind, the heart, the body, the creativity, and the character." },
      {
        type: "image",
        src: "https://images.pexels.com/photos/15119089/pexels-photo-15119089.jpeg?w=1200",
        caption: "At Aadi Gayanam, every child is celebrated as a whole person."
      },

      { type: "heading", text: "Five Pillars of a Whole Child" },
      { type: "paragraph", text: "Our curriculum, our classrooms, and our teachers are all shaped around these five interconnected pillars. When we nurture all five, we do not just raise good students — we raise good human beings." },

      { type: "subheading", text: "1. The Curious Mind" },
      { type: "paragraph", text: "We do not teach children what to think — we help them learn how to think. Every activity is designed to spark wonder, encourage questions, and build confidence in exploration." },
      { type: "bullets", items: [
        "Phonics, storytelling and language-rich conversations",
        "Early mathematics through play, patterns and puzzles",
        "Nature-based science observations",
        "Sanskrit sounds and shlokas to strengthen memory and focus",
        "Open-ended questions that invite children's own ideas"
      ]},

      { type: "subheading", text: "2. The Loving Heart" },
      { type: "paragraph", text: "Emotional intelligence is one of the greatest gifts we can give a child. Our teachers create a warm, safe space where every emotion is welcomed and understood." },
      { type: "bullets", items: [
        "Circle time to share feelings and stories",
        "Kindness rituals and gratitude practice",
        "Peer collaboration and cooperative play",
        "Values-based stories from the Ramayana, Panchatantra and beyond",
        "Empathy through role-play and dramatic activities"
      ]},

      { type: "subheading", text: "3. The Strong Body" },
      { type: "paragraph", text: "Physical wellness is the foundation of learning. We integrate movement, yoga, and outdoor play into every day so children grow up healthy, coordinated and full of energy." },
      { type: "bullets", items: [
        "Daily yoga and simple pranayam for kids",
        "Outdoor play in safe, nature-inspired zones",
        "Fine motor activities through art and craft",
        "Rhythmic movement, dance and free play",
        "Sattvik meals and healthy eating habits"
      ]},

      { type: "subheading", text: "4. The Bright Creativity" },
      { type: "paragraph", text: "Creativity is not a luxury — it is a skill that children carry for life. We give them the tools, freedom and permission to imagine boldly." },
      { type: "bullets", items: [
        "Art, painting, clay modelling and colour exploration",
        "Music, singing and Indian classical rhythms",
        "Storytelling and drama sessions",
        "Puppet shows and pretend play corners",
        "Loose-parts play that invites open-ended creativity"
      ]},

      { type: "subheading", text: "5. The Rooted Character" },
      { type: "paragraph", text: "A child who is rooted in values grows into an adult who lives with purpose. Our sanskaar-based education is not a lecture — it is a way of life we live with our children every day." },
      { type: "bullets", items: [
        "Simple Sanskrit shlokas woven into daily routines",
        "Celebration of Bharatiya festivals and traditions",
        "Stories that teach honesty, courage, humility and service",
        "Respect for parents, elders, teachers and nature",
        "Little acts of seva and everyday responsibility"
      ]},

      { type: "heading", text: "A Day at Aadi Gayanam" },
      { type: "paragraph", text: "Every day at Aadi Gayanam is a joyful rhythm of learning, love and laughter. We don't rush children — we walk with them at their pace." },
      { type: "bullets", items: [
        "Warm welcome and morning prayer",
        "Sanskrit shloka circle and short meditation",
        "Play-based learning stations",
        "Creative art or music session",
        "Outdoor play and yoga time",
        "Story time with Indian tales and picture books",
        "Reflection, gratitude and a joyful goodbye"
      ]},
      { type: "paragraph", text: "By the end of the day, our children have not just learned — they have grown." },

      { type: "heading", text: "Our Promise to Parents" },
      { type: "paragraph", text: "When you join the Aadi Gayanam family, we promise to walk with you as a true partner in your child's early years." },
      { type: "bullets", items: [
        "Loving teachers who see your child as their own",
        "Safe, hygienic and thoughtfully designed spaces",
        "Regular communication and parent-teacher partnership",
        "A curriculum that respects your child's unique pace",
        "A joyful atmosphere where children can't wait to come to school",
        "Grounding in Sanatan values without losing modern relevance"
      ]},

      { type: "heading", text: "Why Holistic Education Matters More Than Ever" },
      { type: "paragraph", text: "We live in a world of screens, speed and stress. In such a world, the greatest gift we can give a child is not more information — but a strong foundation of curiosity, empathy, well-being, imagination and inner strength." },
      { type: "paragraph", text: "Research consistently shows that children who experience holistic early education grow into adults who are more resilient, more creative, more compassionate and more successful — not just in careers, but in life." },
      { type: "paragraph", text: "This is exactly the kind of childhood every child deserves. This is the childhood Aadi Gayanam is designed to offer." },

      { type: "heading", text: "The Aadi Gayanam Promise" },
      { type: "paragraph", text: "Join the Aadi Gayanam family and give your child an education that nurtures the mind, heart, body, creativity, and character. Together, let us build a generation that learns with joy, leads with wisdom, and lives with purpose." },
      { type: "paragraph", text: "Because when we shape the child, we shape the future of Bharat." }
    ],
    content: "Join the Aadi Gayanam family and give your child an education that nurtures the mind, heart, body, creativity, and character."
  },
  {
    id: "ideal-age-for-daycare-indian-parents",
    title: "Choosing the Ideal Age for Daycare: A Guide for Indian Parents",
    excerpt: "Every child grows at their own pace. The right time to begin daycare is when the child is emotionally ready, the family is comfortable, and the environment is safe, nurturing, and loving.",
    image: "https://images.unsplash.com/photo-1541560052-77ec1bbc09f7?w=1200",
    author: "Team Aadi Gayanam",
    date: "2026-07-18",
    readTime: "9 min read",
    category: "Parenting",
    featured: true,
    sanskritQuote: {
      sanskrit: "बालानां प्रियं शिक्षणम्।",
      meaning: "Learning is most meaningful when it is joyful. Give your child the opportunity to learn, grow, and thrive in a caring environment where every smile, every discovery, and every milestone is celebrated."
    },
    sections: [
      { type: "paragraph", text: "One of the most common questions parents ask is, \"What is the right age to send my child to daycare?\"" },
      { type: "paragraph", text: "For Indian families, this decision often involves balancing career responsibilities, family support, and the child's emotional and developmental needs. While there is no universal answer, understanding your child's readiness and selecting a high-quality daycare can make the transition smooth and rewarding." },
      { type: "paragraph", text: "At Aadi Gayanam Play School, we believe daycare should be much more than a place where children spend time. It should be a warm, secure environment where they feel loved, explore confidently, and develop essential life skills." },

      { type: "heading", text: "What Is Daycare?" },
      { type: "paragraph", text: "Daycare is a professionally supervised environment where infants, toddlers, and preschool children receive care while their parents are at work or engaged in other responsibilities." },
      { type: "paragraph", text: "A quality daycare offers:" },
      { type: "bullets", items: [
        "Safe and hygienic surroundings",
        "Age-appropriate learning activities",
        "Nutritious meals and snacks",
        "Supervised indoor and outdoor play",
        "Rest and nap routines",
        "Social interaction with other children",
        "Emotional care and attention"
      ]},
      { type: "paragraph", text: "The goal is to support a child's physical, emotional, social, and cognitive development." },

      { type: "heading", text: "What Is the Ideal Age for Daycare?" },
      { type: "paragraph", text: "There is no fixed age that suits every child. However, child development experts generally recommend the following:" },

      { type: "subheading", text: "6–12 Months: Limited Daycare (If Necessary)" },
      { type: "paragraph", text: "Some families require daycare due to work commitments. At this stage, babies need:" },
      { type: "bullets", items: [
        "Consistent caregivers",
        "Individual attention",
        "Feeding and sleeping routines",
        "Gentle sensory experiences",
        "Emotional security"
      ]},
      { type: "paragraph", text: "If daycare is necessary, choose one with a low caregiver-to-child ratio and excellent hygiene standards." },

      { type: "subheading", text: "12–24 Months: A Gentle Introduction" },
      { type: "paragraph", text: "Many toddlers begin adapting well to daycare during this period. Children start to:" },
      { type: "bullets", items: [
        "Walk independently",
        "Recognize familiar routines",
        "Explore their surroundings",
        "Develop basic communication skills",
        "Build secure relationships with caregivers"
      ]},
      { type: "paragraph", text: "Short daycare sessions often work best in the beginning." },

      { type: "subheading", text: "2–3 Years: The Ideal Starting Age" },
      { type: "paragraph", text: "For many children, this is an excellent age to begin regular daycare. They become more comfortable with:" },
      { type: "bullets", items: [
        "Playing alongside other children",
        "Following simple instructions",
        "Participating in group activities",
        "Learning through music, stories, and play",
        "Building independence"
      ]},
      { type: "paragraph", text: "Children also begin preparing naturally for nursery school." },

      { type: "subheading", text: "3–5 Years: Preschool with Extended Care" },
      { type: "paragraph", text: "At this stage, daycare complements preschool education. Children enjoy:" },
      { type: "bullets", items: [
        "Structured learning",
        "Creative activities",
        "Outdoor games",
        "Art and craft",
        "Storytelling",
        "Yoga and movement",
        "Early literacy and numeracy",
        "Group projects"
      ]},
      { type: "paragraph", text: "Their confidence and communication skills improve significantly." },

      { type: "heading", text: "Signs Your Child Is Ready for Daycare" },
      { type: "paragraph", text: "Every child develops differently, but these signs often indicate readiness:" },
      { type: "bullets", items: [
        "Comfortable staying with trusted adults",
        "Curious about new surroundings",
        "Enjoys observing or playing with other children",
        "Can follow simple routines",
        "Begins expressing basic needs",
        "Shows increasing independence"
      ]},
      { type: "paragraph", text: "Some children adapt within days, while others may need a few weeks." },

      { type: "heading", text: "Benefits of Daycare" },

      { type: "subheading", text: "1. Social Development" },
      { type: "paragraph", text: "Children learn how to:" },
      { type: "bullets", items: [
        "Share toys",
        "Wait patiently",
        "Cooperate",
        "Make friends",
        "Resolve small conflicts",
        "Respect others"
      ]},
      { type: "paragraph", text: "These social experiences prepare them for school and life." },

      { type: "subheading", text: "2. Language Growth" },
      { type: "paragraph", text: "Daily conversations, songs, rhymes, and storytelling enrich vocabulary and improve communication skills. Children become more confident in expressing themselves." },

      { type: "subheading", text: "3. Emotional Development" },
      { type: "paragraph", text: "Good daycare helps children:" },
      { type: "bullets", items: [
        "Build self-confidence",
        "Manage separation from parents",
        "Express emotions appropriately",
        "Feel secure in new environments"
      ]},
      { type: "paragraph", text: "Supportive caregivers play a key role in nurturing emotional well-being." },

      { type: "subheading", text: "4. Learning Through Play" },
      { type: "paragraph", text: "Children learn naturally through activities such as:" },
      { type: "bullets", items: [
        "Building blocks",
        "Puzzles",
        "Music",
        "Dance",
        "Painting",
        "Water play",
        "Sand play",
        "Pretend play"
      ]},
      { type: "paragraph", text: "These experiences develop creativity, coordination, and problem-solving abilities." },

      { type: "subheading", text: "5. Healthy Routine" },
      { type: "paragraph", text: "A structured daily schedule helps children develop:" },
      { type: "bullets", items: [
        "Consistent eating habits",
        "Regular sleep routines",
        "Hygiene practices",
        "Time management",
        "Self-discipline"
      ]},
      { type: "paragraph", text: "Predictable routines also provide a sense of security." },

      { type: "heading", text: "Common Concerns of Indian Parents" },

      { type: "subheading", text: "\"Will my child cry?\"" },
      { type: "paragraph", text: "Yes, some children cry during the initial days. This is a normal part of adjusting to a new environment. With patience and consistent routines, most children settle in within a few weeks." },

      { type: "subheading", text: "\"Will daycare affect bonding with parents?\"" },
      { type: "paragraph", text: "No. A loving relationship at home remains the strongest influence on a child's emotional development. Quality time before and after daycare strengthens this bond." },

      { type: "subheading", text: "\"Will my child learn bad habits?\"" },
      { type: "paragraph", text: "Children learn from both peers and adults. Choosing a daycare with experienced, caring teachers and clear values helps create a positive learning environment." },

      { type: "subheading", text: "\"Is my child too young?\"" },
      { type: "paragraph", text: "If your child needs daycare because of family circumstances, a nurturing environment with responsive caregivers can support healthy development. The quality of care matters more than the exact age." },

      { type: "heading", text: "Tips for a Smooth Transition" },
      { type: "paragraph", text: "Help your child adjust by:" },
      { type: "bullets", items: [
        "Visiting the daycare together before admission",
        "Introducing caregivers gradually",
        "Following a consistent morning routine",
        "Packing a favorite comfort toy if allowed",
        "Saying goodbye confidently without lingering",
        "Praising your child's efforts after each day",
        "Communicating regularly with teachers"
      ]},
      { type: "paragraph", text: "A calm and positive attitude from parents helps children feel secure." },

      { type: "heading", text: "How to Choose the Right Daycare" },
      { type: "paragraph", text: "Before enrolling your child, consider the following:" },
      { type: "bullets", items: [
        "Safe and secure premises",
        "Clean classrooms and play areas",
        "Caring and trained staff",
        "Low caregiver-to-child ratio",
        "Child-friendly learning environment",
        "CCTV and safety procedures",
        "Healthy meals and hygiene practices",
        "Regular communication with parents",
        "Emergency medical readiness",
        "Positive reviews and recommendations"
      ]},
      { type: "paragraph", text: "A visit to the daycare can help you assess whether it feels welcoming and child-centered." },

      { type: "heading", text: "Why Families Choose Aadi Gayanam Play School" },
      { type: "paragraph", text: "At Aadi Gayanam Play School, we provide a nurturing environment where children feel safe, valued, and inspired to learn every day." },
      { type: "paragraph", text: "Our daycare features:" },
      { type: "bullets", items: [
        "Loving and experienced caregivers",
        "Safe, hygienic, and child-friendly facilities",
        "Age-appropriate play-based curriculum",
        "Storytelling, music, yoga, and creative arts",
        "Indian cultural values and celebrations",
        "Nutritious meals and healthy routines",
        "Regular updates for parents",
        "Individual attention for every child"
      ]},
      { type: "paragraph", text: "We believe every child deserves a joyful beginning filled with care, curiosity, and confidence." },

      { type: "heading", text: "Final Thoughts" },
      { type: "paragraph", text: "There is no perfect age that suits every child. The best time to begin daycare depends on your child's temperament, your family's needs, and the quality of the daycare environment." },
      { type: "paragraph", text: "When children are cared for with patience, love, and respect, daycare becomes an enriching experience that supports their emotional, social, physical, and intellectual growth." },
      { type: "paragraph", text: "At Aadi Gayanam Play School, we are committed to partnering with parents to create a strong foundation for every child's future." }
    ],
    content: "Every child grows at their own pace. The right time to begin daycare is when the child is emotionally ready, the family is comfortable, and the environment is safe, nurturing, and loving."
  },
  {
    id: "parents-guide-nursery-education",
    title: "A Parent's Guide to Nursery Education: What to Expect in the Early Years",
    excerpt: "The first five years of life lay the foundation for a child's future. A nurturing nursery education builds confidence, curiosity, and character that last a lifetime.",
    image: "https://images.pexels.com/photos/7104190/pexels-photo-7104190.jpeg?w=1200",
    author: "Team Aadi Gayanam",
    date: "2026-07-17",
    readTime: "10 min read",
    category: "Parenting",
    featured: true,
    sanskritQuote: {
      sanskrit: "विद्या ददाति विनयं, विनयाद् याति पात्रताम्।\nपात्रत्वात् धनमाप्नोति, धनात् धर्मं ततः सुखम्॥",
      meaning: "Knowledge gives humility, humility leads to worthiness, worthiness brings prosperity, prosperity enables righteousness, and righteousness leads to lasting happiness."
    },
    sections: [
      {
        type: "paragraph",
        text: "Choosing the right nursery school is one of the most important decisions parents make. The early years are not just about learning the alphabet and numbers — they are about developing confidence, social skills, emotional intelligence, creativity, and a lifelong love for learning."
      },
      {
        type: "paragraph",
        text: "At Aadi Gayanam Play School, we believe every child is unique and deserves a joyful, safe, and inspiring environment where learning happens naturally through play, exploration, and meaningful experiences."
      },
      {
        type: "paragraph",
        text: "This guide will help parents understand what nursery education involves and what they can expect during these precious early years."
      },
      {
        type: "heading",
        text: "Why Nursery Education Matters"
      },
      {
        type: "paragraph",
        text: "Research shows that children who receive quality early childhood education are more likely to:"
      },
      {
        type: "bullets",
        items: [
          "Develop strong language and communication skills",
          "Build healthy social relationships",
          "Become confident and independent learners",
          "Improve problem-solving and critical thinking abilities",
          "Adapt easily to primary school",
          "Develop emotional resilience and self-confidence"
        ]
      },
      {
        type: "paragraph",
        text: "Nursery education lays the foundation for lifelong success."
      },
      {
        type: "heading",
        text: "What Children Learn in Nursery"
      },
      {
        type: "paragraph",
        text: "A quality nursery curriculum focuses on holistic development rather than academic pressure."
      },
      { type: "subheading", text: "1. Language Development" },
      { type: "paragraph", text: "Children learn to:" },
      {
        type: "bullets",
        items: [
          "Listen carefully",
          "Speak confidently",
          "Build vocabulary",
          "Enjoy stories and rhymes",
          "Recognize letters and sounds",
          "Express their thoughts and feelings"
        ]
      },
      { type: "paragraph", text: "Storytelling, conversations, music, and picture books make language learning enjoyable." },

      { type: "subheading", text: "2. Early Mathematics" },
      { type: "paragraph", text: "Children explore mathematical concepts through play:" },
      {
        type: "bullets",
        items: [
          "Counting objects",
          "Number recognition",
          "Shapes",
          "Patterns",
          "Sorting",
          "Comparing sizes",
          "Measuring",
          "Simple problem-solving"
        ]
      },
      { type: "paragraph", text: "Learning mathematics becomes fun through games, puzzles, and everyday activities." },

      { type: "subheading", text: "3. Physical Development" },
      { type: "paragraph", text: "Healthy movement is essential for growing children. Activities include:" },
      {
        type: "bullets",
        items: [
          "Running",
          "Jumping",
          "Balancing",
          "Dancing",
          "Yoga",
          "Ball games",
          "Fine motor activities",
          "Art and craft"
        ]
      },
      { type: "paragraph", text: "These activities strengthen muscles, improve coordination, and develop confidence." },

      { type: "subheading", text: "4. Social and Emotional Skills" },
      { type: "paragraph", text: "Children gradually learn how to:" },
      {
        type: "bullets",
        items: [
          "Share",
          "Cooperate",
          "Wait patiently",
          "Respect others",
          "Express emotions",
          "Build friendships",
          "Solve conflicts peacefully",
          "Develop empathy"
        ]
      },
      { type: "paragraph", text: "These life skills are just as important as academics." },

      { type: "subheading", text: "5. Creativity and Imagination" },
      { type: "paragraph", text: "Creative activities encourage children to think independently. Examples include:" },
      {
        type: "bullets",
        items: [
          "Drawing",
          "Painting",
          "Clay modelling",
          "Music",
          "Dance",
          "Drama",
          "Puppet shows",
          "Pretend play"
        ]
      },
      { type: "paragraph", text: "Creativity helps children become confident problem-solvers." },

      { type: "subheading", text: "6. Nature and Environmental Awareness" },
      { type: "paragraph", text: "Children naturally love exploring nature. They learn through:" },
      {
        type: "bullets",
        items: [
          "Gardening",
          "Nature walks",
          "Caring for plants",
          "Bird watching",
          "Water play",
          "Sand play",
          "Seasonal observations"
        ]
      },
      { type: "paragraph", text: "These experiences develop curiosity and responsibility." },

      { type: "heading", text: "A Typical Nursery School Day" },
      { type: "paragraph", text: "A balanced routine helps children feel secure. A typical day may include:" },
      {
        type: "bullets",
        items: [
          "Morning welcome",
          "Prayer or mindfulness",
          "Circle time",
          "Storytelling",
          "Learning activities",
          "Outdoor play",
          "Snack time",
          "Music and movement",
          "Creative art",
          "Free play",
          "Reflection and goodbye"
        ]
      },
      { type: "paragraph", text: "Children thrive with a predictable yet flexible schedule." },

      { type: "heading", text: "Learning Through Play" },
      { type: "paragraph", text: "Play is the natural language of childhood. When children play, they learn to:" },
      {
        type: "bullets",
        items: [
          "Think creatively",
          "Solve problems",
          "Build friendships",
          "Communicate effectively",
          "Develop confidence",
          "Explore new ideas"
        ]
      },
      { type: "paragraph", text: "Play-based education encourages curiosity without pressure." },

      { type: "heading", text: "How Parents Can Support Learning at Home" },
      { type: "paragraph", text: "Parents are a child's first teachers. Simple daily activities make a big difference:" },
      {
        type: "bullets",
        items: [
          "Read together every day",
          "Talk about your child's experiences",
          "Encourage questions",
          "Allow independent play",
          "Limit unnecessary screen time",
          "Involve children in household tasks",
          "Appreciate effort rather than perfection",
          "Celebrate small achievements"
        ]
      },
      { type: "paragraph", text: "Learning continues beyond the classroom." },

      { type: "heading", text: "Developing Good Habits" },
      { type: "paragraph", text: "Nursery education also focuses on life skills. Children learn:" },
      {
        type: "bullets",
        items: [
          "Personal hygiene",
          "Hand washing",
          "Table manners",
          "Organizing belongings",
          "Respecting elders",
          "Caring for the environment",
          "Following routines",
          "Responsibility"
        ]
      },
      { type: "paragraph", text: "These habits prepare children for future success." },

      { type: "heading", text: "Building Confidence" },
      { type: "paragraph", text: "Confidence grows through encouragement rather than comparison. Teachers help children by:" },
      {
        type: "bullets",
        items: [
          "Praising effort",
          "Giving opportunities to participate",
          "Encouraging independent thinking",
          "Respecting individual learning styles",
          "Celebrating every child's progress"
        ]
      },
      { type: "paragraph", text: "Every child develops at their own pace." },

      { type: "heading", text: "The Importance of Indian Values" },
      { type: "paragraph", text: "At Aadi Gayanam Play School, education is rooted in Indian culture and universal values. Children are introduced to:" },
      {
        type: "bullets",
        items: [
          "Respect for parents and teachers",
          "Kindness and compassion",
          "Gratitude",
          "Honesty",
          "Discipline",
          "Yoga",
          "Sanskrit shlokas",
          "Festivals of India",
          "Stories from the Ramayana, Mahabharata, Panchatantra, and inspiring lives of great personalities"
        ]
      },
      { type: "paragraph", text: "Our aim is to nurture children who are both globally aware and deeply connected to their cultural heritage." },

      { type: "heading", text: "Parent-School Partnership" },
      { type: "paragraph", text: "A child's success depends on strong collaboration between parents and teachers. Effective partnerships include:" },
      {
        type: "bullets",
        items: [
          "Regular communication",
          "Parent-teacher meetings",
          "Sharing developmental milestones",
          "Supporting classroom learning at home",
          "Celebrating achievements together"
        ]
      },
      { type: "paragraph", text: "When home and school work together, children flourish." },

      { type: "heading", text: "Signs of a Quality Nursery School" },
      { type: "paragraph", text: "When selecting a nursery, look for:" },
      {
        type: "bullets",
        items: [
          "Safe and child-friendly campus",
          "Qualified and caring teachers",
          "Low teacher-child ratio",
          "Play-based curriculum",
          "Clean classrooms",
          "Outdoor play area",
          "Strong safety measures",
          "Positive discipline methods",
          "Parent engagement",
          "Focus on holistic development"
        ]
      },
      { type: "paragraph", text: "The right environment makes learning joyful." },

      { type: "heading", text: "Final Thoughts" },
      { type: "paragraph", text: "The early years are a once-in-a-lifetime opportunity to shape a child's future. A quality nursery education is not about rushing children into academics — it is about nurturing happy, confident, curious, and compassionate learners." },
      { type: "paragraph", text: "At Aadi Gayanam Play School, we are committed to providing a joyful learning environment where every child is encouraged to explore, discover, and grow with confidence. Through play, creativity, Indian values, and holistic education, we prepare children not just for school — but for life." }
    ],
    content: "The first five years of life lay the foundation for a child's future. A nurturing nursery education builds confidence, curiosity, and character that last a lifetime. Read on to discover what makes early childhood education truly transformative."
  },
  {
    id: "sanskrit-shlokas-for-kids",
    title: "Why Sanskrit Shlokas Are a Superpower for Young Minds",
    excerpt: "Discover how simple Sanskrit shlokas improve memory, concentration and pronunciation in preschool-aged children while grounding them in Bharatiya culture.",
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800",
    author: "Team Aadi Gayanam",
    date: "2025-08-12",
    readTime: "5 min read",
    category: "Sanskaar",
    content: "Sanskrit is often called the mother of all languages, and its shlokas offer more than just spiritual value — they are a scientifically proven cognitive workout for young minds. When a 3-year-old child chants 'Vakratunda Mahakaya', multiple regions of the brain fire up together: auditory processing, verbal memory, rhythm sensing and motor coordination. At Aadi Gayanam, we introduce shlokas in bite-sized, playful ways so children fall in love with the sounds long before they understand the meaning."
  },
  {
    id: "yoga-preschoolers-benefits",
    title: "5 Reasons Every Preschooler Should Practice Yoga Daily",
    excerpt: "From improving focus to building flexibility and emotional regulation — yoga is a gift you can give your little one for life. Here's why we make it part of every school day.",
    image: "https://images.unsplash.com/photo-1552196563-55cd4e45efb3?w=800",
    author: "Team Aadi Gayanam",
    date: "2025-08-05",
    readTime: "4 min read",
    category: "Wellness",
    content: "Yoga is not just for adults. In fact, preschool years are the perfect time to introduce yoga because children are naturally flexible, curious and open to imitation. At Aadi Gayanam, we combine simple asanas with animal sounds, breathing games and short guided visualizations to make every session feel like play. The results are magical — calmer children, better sleep, improved focus and stronger bodies."
  },
  {
    id: "sanatan-modern-learning-balance",
    title: "Balancing Sanatan Values with Modern Learning: The Aadi Gayanam Way",
    excerpt: "How do you raise a child who knows the Ramayana AND builds LEGO robots? Here's our approach to seamlessly blending tradition and innovation.",
    image: "https://images.pexels.com/photos/3662629/pexels-photo-3662629.jpeg?w=800",
    author: "Team Aadi Gayanam",
    date: "2025-07-28",
    readTime: "6 min read",
    category: "Philosophy",
    content: "The best gift we can give our children is roots and wings. Roots that keep them grounded in Sanatan values, and wings that help them soar in a globalized world. At Aadi Gayanam, we don't see tradition and modernity as opposites — we see them as complementary. Our curriculum weaves shlokas with phonics, yoga with STEM basics, and Ramayana stories with problem-solving skills."
  },
  {
    id: "choosing-right-playschool-jaipur",
    title: "How to Choose the Right Play School in Jaipur: A Parent's Checklist",
    excerpt: "A practical, no-nonsense guide for Jaipur parents evaluating preschools. Ten questions you must ask before you enroll your little one anywhere.",
    image: "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=800",
    author: "Team Aadi Gayanam",
    date: "2025-07-20",
    readTime: "7 min read",
    category: "Parenting",
    content: "Choosing a play school is one of the most important decisions you'll make as a parent. In Jaipur alone, there are hundreds of options — big brands, small setups, home-based playgroups. So how do you pick the right one? Here's our parent-tested checklist: 1) Teacher-to-child ratio, 2) Safety and hygiene, 3) Curriculum philosophy, 4) Faculty qualifications, 5) Parent involvement, 6) Values alignment, 7) Meal quality, 8) Play spaces, 9) Cultural exposure, 10) Your child's happiness on trial day."
  },
  {
    id: "importance-early-childhood-education",
    title: "The First 6 Years: Why Early Childhood Education Shapes a Lifetime",
    excerpt: "Research shows 90% of a child's brain develops before age 6. Learn why the play school years are the most critical investment in your child's future.",
    image: "https://images.unsplash.com/photo-1595351298020-038700609878?w=800",
    author: "Team Aadi Gayanam",
    date: "2025-07-10",
    readTime: "5 min read",
    category: "Development",
    content: "Neuroscience is clear: 90% of a child's brain development happens before the age of 6. These aren't just academic years — they are the foundation years for language, empathy, curiosity, focus and social skills. A good play school doesn't just teach ABCs and 123s — it shapes how a child thinks, feels and relates to the world for the rest of their life."
  },
  {
    id: "traditional-indian-stories-for-kids",
    title: "10 Timeless Indian Stories Every Child Should Grow Up With",
    excerpt: "From Krishna's mischief to Hanuman's devotion — Bharat is a treasure trove of stories that teach values without ever being preachy. Here are our top picks.",
    image: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=800",
    author: "Team Aadi Gayanam",
    date: "2025-06-30",
    readTime: "6 min read",
    category: "Sanskaar",
    content: "Long before there were textbooks, there were stories. And no culture has richer, more layered, more character-shaping stories than Bharat. From Panchatantra to Ramayana, from Krishna's leelas to Buddha's teachings — these tales quietly plant the seeds of empathy, courage, honesty and wisdom. At Aadi Gayanam, story time is sacred."
  }
];
